import { AppDispatch } from 'redux/store';
import PusherChannelNames from 'shared/services/pusher-channel-names';
import { updateSessionPreparationNote } from 'redux/actions/mentoring-program-sessions';
import { Event, EventList, EventType, PreparationNoteGeneratedEvent } from './event-types';
import { configureChannel } from './utils';

const getEvents = (): EventList => [
  {
    name: EventType.PREPARATION_NOTE_GENERATED,
    handler: (event: Event, dispatch: AppDispatch) => {
      const { mentorshipProgramSessionId, preparationNote, conversationStarters } = event as PreparationNoteGeneratedEvent;
      dispatch(updateSessionPreparationNote({
        sessionId: mentorshipProgramSessionId,
        preparationNote,
        conversationStarters,
      }));
    },
  },
];

const setupMenteeLensEventsListener = (
  sessionId: number,
  dispatch: AppDispatch,
) => {
  const channelName = PusherChannelNames.mentoringProgramSessionChannel(sessionId);
  return configureChannel(channelName, getEvents(), dispatch);
};

export default setupMenteeLensEventsListener;
